import styled from 'styled-components';

export const ContainerFluid = styled.div`
  width: 100%;
  padding: 0;
  flex: 1 1 auto;
`;
